import axios from "axios";

let httpLink = 'https://appstest.cibercolegios.com/api/vendor_security';
//let httpLink = 'http://localhost:8080';

if (process.env.PUBLIC_URL.indexOf('appsprod') >= 0) {
    httpLink = 'https://appsprod.cibercolegios.com/api/vendor_security';
} 

export const sessionStart=(token)=>{
    return axios.get(httpLink+ '/public/session-start/', {
        headers: {
            'auth_token': token
        }
    });
};